import { REDUCER_NAME } from './const'
import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const FIND_ALL_USER_REQUEST = NS + 'FIND_ALL_USER_REQUEST'
export const FIND_ALL_USER_SUCCESS = NS + 'FIND_ALL_USER_SUCCESS'
export const FIND_ALL_USER_ERROR = NS + 'FIND_ALL_USER_ERROR'

export const CHANGE_CURRENT_USER_ID = NS + 'CHANGE_CURRENT_USER_ID'

export const CHANGE_USER = NS + 'CHANGE_USER'

export const TOGGLE_ROLE = NS + 'TOGGLE_ROLE'
export const TOGGLE_WIDGET_ACCESS = NS + 'TOGGLE_WIDGET_ACCESS'

export const CREATE_EMPLOYEE = NS + 'CREATE_EMPLOYEE'
export const CREATE_EXTERNAL_USER = NS + 'CREATE_EXTERNAL_USER'

export const CHANGE_EXTERNAL_USER = NS + 'CHANGE_EXTERNAL_USER'

export const SAVE_USER_REQUEST = NS + 'SAVE_USER_REQUEST'
export const SAVE_USER_SUCCESS = NS + 'SAVE_USER_SUCCESS'
export const SAVE_USER_ERROR = NS + 'SAVE_USER_ERROR'

export const GENERATE_NEW_PASSWORD_REQUEST = NS + 'GENERATE_NEW_PASSWORD_REQUEST'
export const GENERATE_NEW_PASSWORD_SUCCESS = NS + 'GENERATE_NEW_PASSWORD_SUCCESS'
export const GENERATE_NEW_PASSWORD_ERROR = NS + 'GENERATE_NEW_PASSWORD_ERROR'

export const CREATE_USER_REQUEST = NS + 'CREATE_USER_REQUEST'
export const CREATE_USER_SUCCESS = NS + 'CREATE_USER_SUCCESS'
export const CREATE_USER_ERROR = NS + 'CREATE_USER_ERROR'

export const SET_USER_VALIDATION_RESULT = NS + 'SET_USER_VALIDATION_RESULT'

export const FIND_ALL_ROLE_REQUEST = NS + 'FIND_ALL_ROLE_REQUEST'
export const FIND_ALL_ROLE_SUCCESS = NS + 'FIND_ALL_ROLE_SUCCESS'
export const FIND_ALL_ROLE_ERROR = NS + 'FIND_ALL_ROLE_ERROR'

export const CHANGE_CURRENT_ROLE_ID = NS + 'CHANGE_CURRENT_ROLE_ID'

export const SAVE_ROLE_REQUEST = NS + 'SAVE_ROLE_REQUEST'
export const SAVE_ROLE_SUCCESS = NS + 'SAVE_ROLE_SUCCESS'
export const SAVE_ROLE_ERROR = NS + 'SAVE_ROLE_ERROR'

export const TOGGLE_ROLE_WIDGET_ACCESS = NS + 'TOGGLE_ROLE_WIDGET_ACCESS'



// WEBPACK FOOTER //
// ./src/modules/security/state/manage/type.js